import * as React from 'react';
import { useRecoilValue } from 'recoil';
import SvgIcon from './SvgIcon';
import Config from '../../../../../../config';
import { TVehicleStatus } from '../../../../Vehicles/types';
import { vehicleWithDataSelector } from '../../../../../store/recoil/vehicles';

interface IVehicleMarkerProps {
  vehicleId: number;
  lat: number; // eslint-disable-line react/no-unused-prop-types
  lng: number; // eslint-disable-line react/no-unused-prop-types
  zIndex: number;
  angle: number;
  status: TVehicleStatus;
  mode: string;
}

export default function VehicleMarker(props: IVehicleMarkerProps): JSX.Element | null {
  const vehicle = useRecoilValue(vehicleWithDataSelector(props.vehicleId));

  if (!vehicle) {
    console.warn('Cannot render vehicle marker for vehicle: ', props.vehicleId);
    return null;
  }

  return (
    <div
      className="vehicle-marker"
      id={`vehicle-marker-${vehicle.id}`}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: props.zIndex,
      }}
    >
      <div style={{ cursor: 'revert' }}>
        <SvgIcon
          vehicle={vehicle}
          isSelected={false}
          forceVehicleTypeId={vehicle.id === Config.mucha ? 999 : undefined}
          status={props.status}
          mode={props.mode}
          angle={props.angle}
        />
      </div>
    </div>
  );
}
